const __WEBPACK_NAMESPACE_OBJECT__ = require("css-minimizer-webpack-plugin");;